import LogoI from "../../img/util/logo.png";
import CarbonaraI from "../../img/menu/carbonara.png";
import MignonFiletI from "../../img/menu/mignonFilet.png";
import SalmonFiletI from "../../img/menu/salmonFilet.png";
import CaesarSaladI from "../../img/menu/caesarSalad.png";
import SliderPhoto1I from "../../img/slider/sliderPhoto1.jpg";
import SliderPhoto2I from "../../img/slider/sliderPhoto2.jpg";
import SliderPhoto3I from "../../img/slider/sliderPhoto3.jpg";
import AboutBGI from "../../img/util/aboutBackground.jpg";
import Cook1I from "../../img/cook/cook1.png";
import Cook2I from "../../img/cook/cook2.png";
import Cook3I from "../../img/cook/cook3.png";
import Cook4I from "../../img/cook/cook4.png";
import SliderMenuPhoto1I from "../../img/sliderMenu/sliderMenuPhoto1.jpg";
import SliderMenuPhoto2I from "../../img/sliderMenu/sliderMenuPhoto2.jpg";
import SliderMenuPhoto3I from "../../img/sliderMenu/sliderMenuPhoto3.jpg";
import SliderMenuPhoto4I from "../../img/sliderMenu/sliderMenuPhoto4.jpg";
import SliderMenuPhoto5I from "../../img/sliderMenu/sliderMenuPhoto5.jpg";
import SliderMenuPhoto6I from "../../img/sliderMenu/sliderMenuPhoto6.jpg";
import SliderMenuPhoto7I from "../../img/sliderMenu/sliderMenuPhoto7.jpg";
import SliderMenuPhoto8I from "../../img/sliderMenu/sliderMenuPhoto8.jpg";
import TripAdvisorI from "../../img/icons/tripadvisor.svg";
import VkI from "../../img/icons/vk.svg";
import YandexI from "../../img/icons/yandex.svg";
import GisI from "../../img/icons/gis.svg";
import VisaI from "../../img/icons/visa.svg";
import MasterCardI from "../../img/icons/mastercard.svg";
import MirI from "../../img/icons/mir.svg";
import SbpI from "../../img/icons/sbp.svg";

export const Logo = LogoI;
export const Carbonara = CarbonaraI
export const MignonFilet = MignonFiletI
export const SalmonFilet = SalmonFiletI
export const CaesarSalad = CaesarSaladI
export const SliderPhoto1 = SliderPhoto1I;
export const SliderPhoto2 = SliderPhoto2I;
export const SliderPhoto3 = SliderPhoto3I;
export const AboutBG = AboutBGI;
export const Cook1 = Cook1I;
export const Cook2 = Cook2I;
export const Cook3 = Cook3I;
export const Cook4 = Cook4I;
export const SliderMenuPhoto1 = SliderMenuPhoto1I;
export const SliderMenuPhoto2 = SliderMenuPhoto2I;
export const SliderMenuPhoto3 = SliderMenuPhoto3I;
export const SliderMenuPhoto4 = SliderMenuPhoto4I;
export const SliderMenuPhoto5 = SliderMenuPhoto5I;
export const SliderMenuPhoto6 = SliderMenuPhoto6I;
export const SliderMenuPhoto7 = SliderMenuPhoto7I;
export const SliderMenuPhoto8 = SliderMenuPhoto8I;
export const TripAdvisor = TripAdvisorI;
export const Vk = VkI;
export const Yandex = YandexI;
export const Gis = GisI;
export const Visa = VisaI;
export const MasterCard = MasterCardI;
export const Mir = MirI;
export const Sbp = SbpI;